<template>
  <div class="mt-md-3 mt-1">
    <div class="sub-title">Leverdatum</div>

    <div class="card card-body bg-light">
      <div class="row">
        <div class="col-md-8">
          <template v-if="loadingQuotationDetails">
            <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
          </template>
          <template v-else>
            <span class="delivery-date">{{ formattedDate | deliveryDate }}</span>
          </template>
        </div>
        <div class="col-md-5 float-right">
          <div @click="showModal" class="link">Wijzig</div>
        </div>
      </div>
    </div>

    <div class="deliverytext" v-html="quotationDetails.delivery_text"></div>

    <b-modal ref="delivery-date-details-modal" id="delivery-date-details-modal" content-class="modal-datepicker" size="sm" hide-footer>
      <template slot="modal-header">
        <h4 class="modal-title">Wijzig leverdatum</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="datepicker">
          <datepicker
            :monday-first="true"
            :inline="true"
            v-model="deliveryDate"
            :disabled-dates="disabledDates"
            :language="nl"
            @selected="hideModal"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker'
  import { MUTATE_DELIVERY_DATE, FETCH_SERVERTIME } from '../../store/types'
  import { nl } from 'vuejs-datepicker/dist/locale'

  import moment from 'moment'

  export default {
    data() {
      return {
        nl: nl,
        serverTime: null,
        stopServerTime: false,
        disabledDates: null
      }
    },
    components: {
      Datepicker
    },
    computed: {
      loadingQuotationDetails() {
        if (!this.$store.getters.loadingQuotationDetails) {
          this.calcDisabledDates()
        }
        return this.$store.getters.loadingQuotationDetails
      },
      quotationDetails() {
        return this.$store.getters.quotationDetails
      },
      cart() {
        return this.$store.getters.cart
      },
      deliveryDate: {
        get() {
          if (this.$store.getters.deliveryDate) {
            return new Date(this.$store.getters.deliveryDate)
          }
          return new Date()
        },
        set(value) {
          this.$store.commit(MUTATE_DELIVERY_DATE, (new Date(value)).toDateString())
        }
      },
      formattedDate() {
        return moment(this.deliveryDate).format('YYYY-MM-DD')
      }
    },
    methods: {
      showModal() {
        this.$refs['delivery-date-details-modal'].show()
      },
      hideModal() {
        this.$refs['delivery-date-details-modal'].hide()
      },
      calcDisabledDates() {
        let closingDays = this.quotationDetails.closingDays.map(x => new Date(x))

        // If only easyW materials? Add one day to the minimal deliverydate, if the (server)time is after 17.00
        let minDeliveryDate = new Date(this.quotationDetails.deliveryDateFirst)
        if (this.isOnlyEasyW()) {
          let currentdate = !this.serverTime ? new Date() : this.serverTime
          if (currentdate.getHours() >= 17) {
            minDeliveryDate.setDate(minDeliveryDate.getDate() + 1)
            // Check if the selected date is still whitin the new range
            let selectedDate = new Date(this.deliveryDate.toDateString())
            if (selectedDate < minDeliveryDate) {
              this.deliveryDate = minDeliveryDate
            }
            // check if the new date is selectable
            while (!this.isSelectableDate(this.deliveryDate, closingDays)) {
              this.deliveryDate.setDate(this.deliveryDate.getDate() + 1)
            }
          }
        }

        // update the datepicker
        this.disabledDates = {
          // Set the to and from dates
          to: minDeliveryDate,
          from: this.quotationDetails.deliveryDateLast ? (new Date(this.quotationDetails.deliveryDateLast)) : null,
          // Disable weekends
          days: [6, 0],
          // Disable an array of dates
          dates: closingDays
        }
      },
      isSelectableDate(date, closingDays) {
        if (date.getDay() === 0 || date.getDay() === 6) {
          return false
        }
        if (closingDays.filter(d => d.toDateString() === date.toDateString()).length > 0) {
          return false
        }
        return true
      },
      updateServerTime() {
        if (!this.serverTime) {
          this.serverTime = this.$store.getters.serverTime ? new Date(this.$store.getters.serverTime) : null
        }
        let that = this
        setTimeout(function() {
          if (that.serverTime) {
            that.serverTime.setMinutes(that.serverTime.getMinutes() + 1)
            // Update datepicker
            that.calcDisabledDates()
          }
          if (!that.stopServerTime) {
            that.updateServerTime()
          }
        }, 60000)
      },
      isOnlyEasyW() {
        return this.cart.materials.filter(m => m.filterDeliveryProgram !== 'Easy W').length === 0
      }
    },
    created() {
      if (this.isOnlyEasyW()) {
        this.$store.dispatch(FETCH_SERVERTIME)
      }
    },
    mounted() {
      if (this.isOnlyEasyW()) {
        this.updateServerTime()
      }
    },
    destroyed() {
      this.stopServerTime = true
    }
  }
</script>

<style lang="scss" scoped>
  .delivery-date {
    font-weight: bold;
  }

  .deliverytext {
    margin: 5px 0;
    color: red;
  }
</style>
